export default "__VITE_PUBLIC_ASSET__2290655c__"